/**
 * Utility functions for handling authentication errors
 */

/**
 * Checks if an error is a BlitzWare authentication error
 * @param {Error} error - The error to check
 * @returns {boolean} - True if it's a BlitzWare auth error
 */
export const isBlitzWareAuthError = (error) => {
  return (
    error.name === "BlitzWareAuthError" ||
    error.message.includes("Refresh token") ||
    error.message.includes("refresh token") ||
    error.message.includes("token expired") ||
    error.message.includes("token is not active")
  );
};

/**
 * Handles BlitzWare authentication errors by clearing tokens and redirecting to login
 * @param {Error} error - The authentication error
 * @param {Function} navigate - React Router navigate function (optional)
 */
export const handleBlitzWareAuthError = (error, navigate = null) => {
  console.warn("BlitzWare authentication error detected:", error.message);

  // Clear stored tokens
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");

  // Redirect to login
  if (navigate) {
    navigate("/login");
  } else {
    window.location.href = "/login";
  }
};

/**
 * Wraps an async function with BlitzWare authentication error handling
 * @param {Function} asyncFn - The async function to wrap
 * @param {Function} navigate - React Router navigate function (optional)
 * @returns {Function} - Wrapped function with error handling
 */
export const withBlitzWareAuthErrorHandling = (asyncFn, navigate = null) => {
  return async (...args) => {
    try {
      return await asyncFn(...args);
    } catch (error) {
      if (isBlitzWareAuthError(error)) {
        handleBlitzWareAuthError(error, navigate);
        throw error; // Re-throw to allow calling code to handle if needed
      }
      throw error;
    }
  };
};
